<template>
  <div v-if="legalNav && legalNav.linkList.length">
    <nav class="flex flex-wrap justify-center lg:justify-start" :aria-label="$t('footer.legalNavigation')">
      <div v-for="(item, idx) in legalNav.linkList" :key="idx" class="my-1 mx-2 lg:m-0">
        <LinkField
          v-bind="item.linkField[0]"
          class="fluid-xs leading-tight whitespace-nowrap"
          :tracking-name="item.linkField[0].text"
          typeName="legalNav"
        />
        <span v-if="idx < legalNav.linkList.length - 1" class="fluid-xs leading-tight mx-2 hidden lg:inline-block"
          >|</span
        >
      </div>

      <div class="my-1 mx-2 lg:m-0">
        <span class="fluid-xs leading-tight mx-2 hidden lg:inline-block">|</span>
        <button class="inline-block fluid-xs leading-tight whitespace-nowrap" @click="openCookieBanner">
          {{ $t('footer.cookieSettings') }}
        </button>
      </div>
    </nav>
    <div class="fluid-xs leading-tight mt-4 text-center md:text-left">
      © {{ year }} BLACKROLL.COM. ALL RIGHTS RESERVED
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import LinkField from '@/components/common/LinkField';

export const LegalNavFragment = gql`
  fragment LegalNavFragment on legalNav_GlobalSet {
    linkList {
      ... on linkListBlock_Entry {
        linkField {
          ...LinkFragment
        }
      }
    }
  }
`;

export default defineNuxtComponent({
  components: { LinkField },
  props: {
    legalNav: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  methods: {
    openCookieBanner() {
      if (window && window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay();
      }
    },
  },
});
</script>
